"use strict";

var Backbone = require("backbone");
var _ = require("underscore");
var $ = require("jquery");
Backbone.$ = $;

var debug = require("debug")("views:OverlayHighlightView");

/**
 * Retronews : positionne un rectangle coloré (css) en surimpression d'une page de document
 */
module.exports = Backbone.View.extend({

    pageModel: null, // pageModel
    highlight: null,
    className: "overlay overlay-highlight",
    events: {},

    initialize: function(options) {
        var T = this;
        _.extend(T, options);
        T.listenTo(T.pageModel, "sync", T.render);
        T.render();
    },

    render: function() {
        var T = this;

        T.$el.html("");
        if (T.pageModel.fetched && T.highlight) {
            debug("render " + T.page);
            var width = T.pageModel.get("width"),
                height = T.pageModel.get("height");

            var $div = $("<div/>", {
                class: "highlight"
            });
            $div.css({
                top: (T.highlight.y * 100 / height) + "%",
                left: (T.highlight.x * 100 / width) + "%",
                height: (T.highlight.height * 100 / height) + "%",
                width: (T.highlight.width * 100 / width) + "%"
            });
            T.$el.append($div);
        }
    },

    close: function() {
        var T = this;
        T.pageModel = null;
        T.highlight = null;
        T.stopListening();
        T.undelegateEvents();
    }
});